import { Location, NavigateFunction } from 'react-router-dom';
import scrollToPage from '../../utils/scrollToPage';
import smallLogo from '../../assets/imgs/hotel_peristil_white.svg';
import { FOOTER, PROPERTY_NAME } from '../../utils/constants';

const Footer = ({
  location,
  navigate,
}: {
  location: Location;
  navigate: NavigateFunction;
}) => {
  return (
    <div id={FOOTER} className='footer'>
      <div className='footer_container container'>
        <div
          className='footer_container_logo'
          onClick={() => scrollToPage('home', location, navigate)}
        >
          <img src={smallLogo} alt={PROPERTY_NAME + ' small logo'} />
        </div>
        <div className='footer_container_contacts'>
          <div className='footer_container_contacts_contact'>
            <p>POWERED BY...</p>
            <p>
              <b>HOTEL PERISTIL</b>
            </p>
            <p>Srebrena Vrata d.o.o.</p>
            <p>
              <a
                href='https://maps.app.goo.gl/s65dpkWJJvGxBDuUA'
                target='_blank'
                rel='noreferrer'
                className='opacity_transition_low'
              >
                Poljana kraljice Jelene 5
              </a>
            </p>
            <p>21000 Split, Croatia</p>
            <p>
              <a href='tel:0038521329070' className='opacity_transition_low'>
                +385 21 329 070
              </a>
            </p>
            <p>
              <a
                href='mailto:booking@hotelperistil.com'
                className='opacity_transition_low'
              >
                booking@hotelperistil.com
              </a>
            </p>
          </div>
        </div>
        <div className='footer_container_bottom'>
          <p>Copyright © Hotel Peristil {new Date().getFullYear()}.</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
